var map = {
	"./1.png": 32725,
	"./10.png": 69137,
	"./11.png": 54920,
	"./2.png": 95998,
	"./3.png": 88135,
	"./4.png": 8520,
	"./5.png": 40561,
	"./6.png": 80666,
	"./7.png": 70499,
	"./8.png": 70308,
	"./9.png": 33549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96261;